import { Component, OnInit } from '@angular/core';
import { Router
} from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { interval } from 'rxjs';
import { AuthService } from '../../authentication/auth.service';
import { AdminService } from '../admin.service';
import { environment } from 'src/environments/environment';


@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.scss']
})
export class AdminComponent implements OnInit {
  public opennav: boolean = false;
  showNav: boolean = false;
  submenu: boolean = false;
  subprocuremenu: boolean = false;
  name: string
  avatar_url;
  first_name;
  no_avatar: boolean;
  notificationDetails = [];
  notificationCount: any;
  isRMS: boolean = false;
  staticAssetsDomain = environment.truventorStaticAssetCdnDomain

  constructor(
    private authService: AuthService,
    private adminService: AdminService,
    private router: Router,
    private toastr: ToastrService,
  ) {
    this.name = localStorage.getItem('name');
    this.first_name = this.name.substring(0, 1);
    this.avatar_url = localStorage.getItem('avatar');
    if (this.avatar_url == null) {
      this.no_avatar = true;
    }
    else {
      this.no_avatar = false;
    }
    if (localStorage.getItem('isRMS') != 'undefined' && localStorage.getItem('isRMS') != 'false') {
      this.isRMS = false;
    } else {
      this.isRMS = true;
    }
  }

  ngOnInit() {
    let source1 = interval(100000);
    let subscribe1 = source1.subscribe(() => { this.getNotification() });
    this.getNotification()
  }

  isLoggedIn(): boolean {
    return this.authService.isLoggedIn();
  }

  isLoggedOut(): boolean {
    return !this.authService.isLoggedIn();
  }

  logout(): void {
    this.authService.logOut();
    this.toastr.success("Logged out successfully.", 'Success', { timeOut: 900 });
  }

  openNav() {
    this.opennav = true;
  }
  closeNav() {
    this.opennav = false;
  }

  openSubMenu() {
    this.submenu = true;
  }

  myProfile() {
    this.router.navigate(['/admin/supplier-profile'])
  }

  getNotification() {
    this.adminService.getNotificationDetails(0, 3).subscribe((res: any) => {
      this.notificationDetails = res.data[0].list;
      this.notificationCount = res.data[0].total_count;
    });
  }

  viewAllNotification() {
    this.router.navigate(['/admin/notification']);
  }

  navigation() {
    let authToken = localStorage.getItem('token');
    window.location.href = "http://dev.control.truventor.com?auth=" + authToken
  }

  toggleSubmenu() {
    this.submenu = !this.submenu;
  }

  getAssetLink(path: string) {
    return path;
    // return `${this.staticAssetsDomain}${path}` //: Uncomment after activating front-door
  }

}
